import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MockupPreviewComponent } from '../mockup-preview/mockup-preview.component';
import { PhotosService } from '../services/photos.service';

@Component({
    selector: 'app-facebook-ad',
    templateUrl: './facebook-ad.component.html',
    styleUrls: ['./facebook-ad.component.css']
})
export class FacebookAdComponent implements OnInit {

    facebookAd = [];

    constructor(private photos: PhotosService, public dialog: MatDialog) { }

    ngOnInit() {
        this.facebookAd = this.photos.facebookAd;
    }

    openDialog(url: string): void {
        if (screen.width > 600) {
            this.dialog.open(MockupPreviewComponent, {
                maxHeight: '90%',
                width: '1000px',
                data: {url: url}
            });
        }
    }

}
